/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { BsImageFill } from 'react-icons/bs';
import Button from '@material-ui/core/Button';
import { useLocation } from 'react-router-dom';
import {
  FormControlLabel, FormGroup, InputLabel, Switch,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import Image from '../../components/image';
import InputFile from '../../components/inputFile';
import Input from '../../components/input';
import HeaderComponent from '../../components/header';
import {
  Form,
  Cards,
  ColumnForm,
  RowForm, Footer,
  ContainerImage,
  RowInput,
  Padding,
  style,
  ContainerLoading,
} from './styles';
import Container from '../../components/container';
import axios from '../../services/axiosServicesPoleposition';
import { Criterios } from '../../interfaces';
import LoadingCommon from '../../components/LoadingCommon';

interface Params {
  nomeDiscration?: string;
  edit?: boolean;
  id: string;
}

const NewDiscrations = () => {
  const statesParams = useLocation<Params>()?.state;
  const [name, setName] = useState<string | null>();
  const [description, setDescription] = useState<string | null>();
  const [target, setTarget] = useState<string>();
  const [score, setScore] = useState<string>();
  const [imgBase64, setImgBase64] = useState<string | null>();
  const [imgBase64Name, setImgBase64Name] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [acumulativo, setAcumulativo] = useState<any>('');
  const [loadingLocalData, setLoadingLocalData] = useState(false);

  useEffect(() => {
    if (statesParams?.edit) {
      getData();
    } else {
      clear();
    }
  }, []);

  const getData = async () => {
    try {
      setLoadingLocalData(true);
      const response = await axios.get(`admin/criterios/v1/${statesParams.nomeDiscration}`);
      const data: Criterios = response?.data?.data;

      setLoadingLocalData(false);
      setName(data.nome);
      setTarget(data.target.toString());
      setScore(data.pontos.toString());
      setDescription(data.descricao || '');
      setImgBase64(data.iconeBase64 ? `data:image/jpeg;base64,${data.iconeBase64}` : null);
      setAcumulativo(data.acumulativo);
    } catch (error) {
      setLoadingLocalData(false);
    }
  };

  const clear = () => {
    setName('');
    setDescription('');
    setTarget('');
    setScore('');
    setImgBase64('');
    setImgBase64Name('');
    setAcumulativo(false);
  };

  const saveOrEdit = async () => {
    try {
      if (
        !name || !description || !target || !score
      ) {
        toast.info('Todos os campos são obrigatórios!');
        return;
      }
      setLoading(true);

      if (statesParams?.edit) {
        await axios.put(`admin/criterios/v1/${statesParams?.id}`, {
          nome: name,
          descricao: description,
          target: Number(target),
          pontos: Number(score),
          acumulativo,
          icone: !imgBase64Name ? undefined : {
            nomeIcone: imgBase64Name || null,
            imagemBase64: imgBase64 ? `${imgBase64?.replace(imgBase64?.includes('jpeg') ? 'data:image/jpeg;base64,' : 'data:image/png;base64,', '')}` : null,
          },
        });
        setLoading(false);

        toast.success('Critério atualizado com sucesso!');
        return;
      }
      await axios.post('admin/criterios/v1', {
        nome: name,
        descricao: description,
        target: Number(target),
        pontos: Number(score),
        acumulativo,
        icone: imgBase64Name ? {
          nomeIcone: imgBase64Name,
          imagemBase64: imgBase64 ? `${imgBase64?.replace(imgBase64?.includes('jpeg') ? 'data:image/jpeg;base64,' : 'data:image/png;base64,', '')}` : null,
        } : null,
      });
      toast.success('Critério salvo com sucesso!');
      clear();
      setLoading(false);
    } catch (err: any) {
      toast.error(`⚠ ${err?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Informe os dados.'}`);
      setLoading(false);
    }
  };

  const handleChange = (event: any) => {
    setAcumulativo(event.target.checked);
  };

  return (
    <Container component="main" maxWidth="xl">
      <HeaderComponent label="Criar critérios" />
      {loadingLocalData ? (
        <ContainerLoading>
          <LoadingCommon />
        </ContainerLoading>
      ) : null}
      {(!loadingLocalData && !statesParams?.edit) || (!loadingLocalData && statesParams?.edit) ? (
        <Cards>
          <Form>
            <RowForm>
              <ColumnForm>
                <Padding>
                  <Input value={name || ''} onChange={setName} type="text" label="Nome" />
                </Padding>
                <Input value={description || ''} onChange={setDescription} type="text" label="Descrição" />
                <RowInput>
                  <Padding>
                    <Input value={target || ''} onChange={setTarget} type="number" label="Target" />
                  </Padding>
                  <Input value={score || ''} onChange={setScore} type="number" label="Pontos" />
                </RowInput>
                <InputLabel style={{ marginTop: 18 }} htmlFor="age-native-simple">Acumulativo</InputLabel>
                <FormGroup>
                  <FormControlLabel style={{ marginTop: 8 }} control={<Switch onChange={handleChange} checked={acumulativo} />} label={acumulativo ? 'Sim' : 'Não'} />
                </FormGroup>
              </ColumnForm>
              <ColumnForm style={style.column}>
                {imgBase64 ? (
                  <ContainerImage>
                    <Image uri={imgBase64} />
                  </ContainerImage>
                ) : <BsImageFill style={{ marginBottom: 105 }} size={60} color="#dddddd" />}
                <InputFile disabled={loading} onChangeFileName={setImgBase64Name} onChange={setImgBase64} style={style.input} />
              </ColumnForm>
            </RowForm>
            <Footer>
              {loading ? (
                <div style={{
                  display: 'flex', justifyContent: 'flex-end', width: '100%', marginRight: 45,
                }}
                >
                  <LoadingCommon />
                </div>
              ) : (
                <Button variant="contained" onClick={() => saveOrEdit()} style={style.text}>
                  {statesParams?.edit ? 'Salvar edição' : 'Salvar'}
                </Button>
              )}
            </Footer>
          </Form>
        </Cards>
      ) : null}
    </Container>
  );
};

export default NewDiscrations;
